import NiceModal from '@ebay/nice-modal-react';
import { Box } from '@mantine/core';

import { useGetTrafficSources } from '../api/getTrafficSources';

import { AddModal } from './AddModal';
import { TrafficSourcesTable } from './Table/Table';

import { AddButton, ListLoader } from '@/components';

export const TrafficSourcesList = () => {
  const { data, isLoading } = useGetTrafficSources();

  if (isLoading) {
    return <ListLoader />;
  }

  if (!data?.trafficSources.length) {
    return <ListAddButton isLoading={isLoading} />;
  }

  return (
    <Box style={{ display: 'grid', height: 'calc(100vh - 105px)', gridTemplateRows: 'auto 70px' }}>
      <Box style={{ overflow: 'auto' }}>
        <TrafficSourcesTable trafficSources={data.trafficSources} />
      </Box>
      <ListAddButton isLoading={isLoading} />
    </Box>
  );
};

function ListAddButton({ isLoading }: { isLoading: boolean }) {
  return (
    <AddButton
      size={60}
      isLoading={isLoading}
      onClick={() =>
        NiceModal.show(AddModal, {
          initialValues: {
            name: '',
            key: '',
            command: '',
          },
        })
      }
    />
  );
}
